import React from 'react'

const NoMatch = () => {
  return (
    <div>404 Not Found</div>
  )
}

export default NoMatch